import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { FormatCurrency } from '@/common/helpers/structure.helper'
import { dataLink } from '@/common/interfaces/Links.interface'

@Component({})
export class WhatsConfig extends Vue {

    public helperFormat         = new FormatCurrency();

    public itemData: dataLink;
    public inputNumero: number  = 1;

    public msgWhats: string = '';
    public numeroWhats: string = '';

    $refs: {
        numeroWhats: HTMLFormElement
    }

    @Prop({default: undefined})
    public data: dataLink;

    @Watch('data')
    onPropertyChanged(value: dataLink) {
        this.itemData = value;
    }

    created(){
        console.log(this.data)
        this.itemData       = this.data;
        
        const msgProp       = this.itemData.whats.text;
        const numProp       = this.itemData.whats.numero;
        this.msgWhats       = msgProp ? msgProp : '';
        this.numeroWhats    = numProp ? numProp : '';
        this.inputNumero    = this.numeroWhats == '' ? 1 : 0;
    }

    public saveModal(){
        this.itemData.whats.text    = this.msgWhats;
        this.itemData.whats.numero  = parseInt(this.inputNumero.toString()) ? '' : this.numeroWhats;

        this.closeModal();
    }

    public focusInput(){
        var input = this.$refs.numeroWhats;
        setTimeout(function(){
            input.focus();
        },50);
    }

    public closeModal(){
        this.$emit('actionModal', false);
    }

}